<template>
  <div class="pc-block__wrap">
    <div class="pc-block">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PcBlock',

}
</script>

<style scoped>

</style>
